import { render, staticRenderFns } from "./kaufstatistik.vue?vue&type=template&id=3995e800&scoped=true&"
import script from "./kaufstatistik.vue?vue&type=script&lang=js&"
export * from "./kaufstatistik.vue?vue&type=script&lang=js&"
import style0 from "./kaufstatistik.vue?vue&type=style&index=0&id=3995e800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3995e800",
  null
  
)

export default component.exports